import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_FriedButton = _resolveComponent("FriedButton");
    return (_openBlock(), _createBlock(_component_FriedButton, {
        class: _normalizeClass([
            'themed-button',
            {
                icon: _ctx.icon,
                dense: _ctx.dense,
                disabled: _ctx.disabled,
                'is-loading': _ctx.isLoading,
                rounded: _ctx.rounded,
                theme: _ctx.theme,
                secondary: _ctx.secondary,
                'disable-hover': _ctx.disableHover,
                'active-custom-hover': _ctx.activeCustomHover,
            },
        ]),
        style: _normalizeStyle(_ctx.buttonStyle),
        loading: _ctx.loadingRecipientInput,
        onClick: _ctx.handleClick,
        onFocus: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('focus'))),
        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('blur')))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            _createElementVNode("span", {
                class: _normalizeClass(['button-loader', { visible: _ctx.isLoading }])
            }, [
                (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_FriedSpinner, {
                        key: 0,
                        size: 30,
                        "current-color": true
                    }))
                    : _createCommentVNode("", true)
            ], 2)
        ]),
        _: 3
    }, 8, ["class", "style", "loading", "onClick"]));
}
